// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.popup_YXKuq {
  font-size:14px;
  background : transparent;
  display : inline-block;
  border : 1px solid transparent;
  padding : 4px 4px;
}

.popup_YXKuq:hover {
  background : #D2D2D2;
}

.popup_YXKuq:focus {
  outline: none;
  border : 1px solid rgba(75, 130, 252, 1.0);
}

.popup_YXKuq.popup-header_U_arW{
  background: transparent;
  width: 48px;
  height: 48px;
  border: 1px solid transparent;
  padding: 6px 1px;
}

.popupContent_DV2Ka .popupItem_ncj7M {
  background: transparent;
  color : #959595;
  border : none;
  display: block;
  padding: 4px 24px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.popupContent_DV2Ka .popupItem_ncj7M.popup-header_U_arW {
  color : #5737BE;
}

.popupContent_DV2Ka .popupDivider_XC5gH {
  height : 1px;
  width : 100%;
  padding: 0;
  margin : 4px 0;
  background: #D2D2D2;
}

.popupContent_DV2Ka .popupItem_ncj7M:hover {
  background : #D2D2D2;
}

.popupContent_DV2Ka .popupItem_ncj7M:active {
  color: #D2D2D2;
  background : #959595;
}

.popupContent_DV2Ka {
  max-height: 40vh;
  overflow-y: auto;
  background : #ffffff;
  border : 1px solid #D2D2D2;
  -webkit-box-shadow: 0 9px 12px -6px rgba(0,0,0,0.1);
          box-shadow: 0 9px 12px -6px rgba(0,0,0,0.1);
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Popup.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,mDAA2C;UAA3C,2CAA2C;AAC7C","sourcesContent":["\n.popup {\n  font-size:14px;\n  background : transparent;\n  display : inline-block;\n  border : 1px solid transparent;\n  padding : 4px 4px;\n}\n\n.popup:hover {\n  background : #D2D2D2;\n}\n\n.popup:focus {\n  outline: none;\n  border : 1px solid rgba(75, 130, 252, 1.0);\n}\n\n.popup.popup-header{\n  background: transparent;\n  width: 48px;\n  height: 48px;\n  border: 1px solid transparent;\n  padding: 6px 1px;\n}\n\n.popupContent .popupItem {\n  background: transparent;\n  color : #959595;\n  border : none;\n  display: block;\n  padding: 4px 24px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.popupContent .popupItem.popup-header {\n  color : #5737BE;\n}\n\n.popupContent .popupDivider {\n  height : 1px;\n  width : 100%;\n  padding: 0;\n  margin : 4px 0;\n  background: #D2D2D2;\n}\n\n.popupContent .popupItem:hover {\n  background : #D2D2D2;\n}\n\n.popupContent .popupItem:active {\n  color: #D2D2D2;\n  background : #959595;\n}\n\n.popupContent {\n  max-height: 40vh;\n  overflow-y: auto;\n  background : #ffffff;\n  border : 1px solid #D2D2D2;\n  box-shadow: 0 9px 12px -6px rgba(0,0,0,0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `popup_YXKuq`,
	"popup-header": `popup-header_U_arW`,
	"popupContent": `popupContent_DV2Ka`,
	"popupItem": `popupItem_ncj7M`,
	"popupDivider": `popupDivider_XC5gH`
};
export default ___CSS_LOADER_EXPORT___;
